import { render, staticRenderFns } from "./SystemClientMinVersion.vue?vue&type=template&id=5fc969f6&scoped=true&"
import script from "./SystemClientMinVersion.vue?vue&type=script&lang=js&"
export * from "./SystemClientMinVersion.vue?vue&type=script&lang=js&"
import style0 from "./SystemClientMinVersion.vue?vue&type=style&index=0&id=5fc969f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc969f6",
  null
  
)

export default component.exports